import { APP_ROUTES } from '@cpd-app/core-module/constants/routes';

/**
 * STAFF-1. Where the one staff workspace opens. Every staff role can see the
 * Analytics pages (counselors and above), so it opens there; the nav then
 * offers DANTES Reporting and Administration to whoever has them.
 */
export const STAFF_HOME = APP_ROUTES.Analytics;

/**
 * A staff sign-in lands straight in the workspace: where the login wall was
 * taking them if it recorded that, otherwise the workspace's first page.
 * There is no dashboard picker any more.
 */
export function staffLandingUrl(
  loginWallRedirectUrl: string | null | undefined
): string {
  return loginWallRedirectUrl || STAFF_HOME;
}
